import * as React from "react";
import { StyledEngineProvider } from "@mui/joy/styles";
import {
  CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
  extendTheme as extendMaterialTheme,
  useColorScheme as useMaterialColorScheme,
} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {
  CssVarsProvider as JoyCssVarsProvider,
  extendTheme as extendJoyTheme,
  useColorScheme as useJoyColorScheme,
} from "@mui/joy/styles";
import GlobalStyles from "@mui/joy/GlobalStyles";
import { BrowserRouter } from "react-router-dom";
import { getUserSettings } from "../services/settingsService";

const materialTheme = extendMaterialTheme();
const joyTheme = extendJoyTheme();

const PreferenceInitializer = () => {
  const { setMode: setMaterialMode } = useMaterialColorScheme();
  const { setMode: setJoyMode } = useJoyColorScheme();

  React.useEffect(() => {
    let active = true;

    const loadPreferences = async () => {
      const settings = await getUserSettings();
      if (!settings || !active) {
        return;
      }

      if (settings.theme) {
        setMaterialMode(settings.theme);
        setJoyMode(settings.theme);
      }
    };

    loadPreferences();

    return () => {
      active = false;
    };
  }, [setMaterialMode, setJoyMode]);

  return null;
};

export function AppProviders({ children }: React.PropsWithChildren) {
  return (
    <StyledEngineProvider injectFirst>
      <BrowserRouter>
        <MaterialCssVarsProvider 
          theme={{ [MATERIAL_THEME_ID]: materialTheme }}
          defaultMode="dark"
        >
          <JoyCssVarsProvider theme={joyTheme} defaultMode="dark">
            <PreferenceInitializer />
            <CssBaseline enableColorScheme />
            <GlobalStyles
              styles={{
                body: {
                  fontFamily: "Roboto, sans-serif",
                  backgroundColor: "var(--joy-palette-background-body)",
                  color: "var(--joy-palette-text-primary)",
                },
              }}
            />
            {children}
          </JoyCssVarsProvider>
        </MaterialCssVarsProvider>
      </BrowserRouter>
    </StyledEngineProvider>
  );
}
